// The theme file is based on the specification at https://system-ui.com/theme
//
// WARNING!
//
// This is an internal file to be consumed by the src-foundations package only
//
// It contains the lowest level primitives for the entire design system.
// Be very, *very* careful when changing the values in here, changes are likely
// to have a wide-ranging impact across all applications
//
// DANGEROUS CHANGES
//
// The following will almost certainly require further changes to src-foundations.
// They will likely also impact every application that consumes src-foundations
//
// - Updating a value
// - Removing a value
// - Inserting a value into an array
//
// SAFE CHANGES
//
// - Pushing a value onto the end of an array
// - Exporting a new object or array
const fontSizes = [12, 14, 15, 17, 20, 24, 28, 34, 42, 50, 70];
const fonts = {
    titlepiece: 'GT Guardian Titlepiece, Georgia, serif',
    headlineSerif: 'GH Guardian Headline, Guardian Egyptian Web, Georgia, serif',
    bodySerif: 'GuardianTextEgyptian, Guardian Text Egyptian Web, Georgia, serif',
    bodySans: 'GuardianTextSans, Guardian Text Sans Web, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif',
};
const lineHeights = [1.15, 1.35, 1.5];
const fontWeights = [300, 400, 500, 700];
// Arrays of colours should have pillar colors first
// e.g. for sport:
// const [sport300, sport400, sport500, sport600, sport800] = colors.blue
const colors = {
    reds: [
        '#660505',
        '#8B0000',
        '#AB0613',
        '#C70000',
        '#FF5943',
        '#FF9081',
        '#FFBAC8',
        '#FFF4F2',
    ],
    oranges: [
        '#672005',
        '#8D2700',
        '#C74600',
        '#E05E00',
        '#FF7F0F',
        '#FF9941',
        '#F9B376',
        '#FEF9F5',
    ],
    blues: [
        '#003C60',
        '#004E7C',
        '#005689',
        '#0077B6',
        '#00B2FF',
        '#90DCFF',
        '#F1F8FC',
        '#001536',
        '#041F4A',
        '#052962',
        '#007ABC',
        '#506991',
        '#C1D8FC',
        '#0093E0',
    ],
    browns: [
        '#2B2625',
        '#3E3323',
        '#574835',
        '#6B5840',
        '#866D50',
        '#A1845C',
        '#EACCA0',
        '#E7D4B9',
        '#EFE8DD',
        '#FBF6EF',
    ],
    pinks: [
        '#510043',
        '#650054',
        '#7D0068',
        '#BB3B80',
        '#FFABDB',
        '#FEC8D3',
        '#FEEEF7',
    ],
    yellows: [
        '#F3C100',
        '#FFD900',
        '#FFE500',
    ],
    greens: [
        '#185E36',
        '#22874D',
        '#58D08B',
        '#4B8878',
        '#65A897',
        '#69D1CA',
    ],
    grays: [
        '#000000',
        '#121212',
        '#1A1A1A',
        '#333333',
        '#707070',
        '#999999',
        '#DCDCDC',
        '#EDEDED',
        '#F6F6F6',
        '#FFFFFF',
        '#222527',
        '#303538',
        '#3F464A',
        '#595C5F',
        '#9DA0A2',
        '#ABC2C9',
        '#E4E5E8',
        '#EFF1F2',
    ],
};
const space = [0, 4, 8, 12, 16, 20, 24, 36, 48, 96];
const size = [24, 36, 44];
const breakpoints = [740, 980, 1140, 1300];
// Diverges from https://system-ui.com
// At these widths, there are tweaks to the
// fluid grid on mobile devices
const tweakpoints = [320, 375, 480, 660];
const transitions = [
    '.2s cubic-bezier(.64, .57, .67, 1.53)',
    '.3s ease-in-out',
    '.65s ease-in-out',
];
export { fontSizes, fonts, lineHeights, fontWeights, colors, space, size, breakpoints, tweakpoints, transitions, };
//# sourceMappingURL=theme.js.map
